import {
  LIST_MCP_CLIENT_VERSIONS_ROUTE,
  CREATE_MCP_CLIENT_VERSION_ROUTE,
  GET_MCP_CLIENT_VERSION_ROUTE,
  ACTIVATE_MCP_CLIENT_VERSION_ROUTE,
  RESTORE_MCP_CLIENT_VERSION_ROUTE,
  DELETE_MCP_CLIENT_VERSION_ROUTE,
  COMPARE_MCP_CLIENT_VERSIONS_ROUTE,
} from '../../handlers/mcp-client-versions';
import {
  LIST_STORED_MCP_CLIENTS_ROUTE,
  GET_STORED_MCP_CLIENT_ROUTE,
  CREATE_STORED_MCP_CLIENT_ROUTE,
  UPDATE_STORED_MCP_CLIENT_ROUTE,
  DELETE_STORED_MCP_CLIENT_ROUTE,
} from '../../handlers/stored-mcp-clients';

export const STORED_MCP_CLIENTS_ROUTES = [
  // Stored MCP Clients CRUD Routes
  LIST_STORED_MCP_CLIENTS_ROUTE,
  GET_STORED_MCP_CLIENT_ROUTE,
  CREATE_STORED_MCP_CLIENT_ROUTE,
  UPDATE_STORED_MCP_CLIENT_ROUTE,
  DELETE_STORED_MCP_CLIENT_ROUTE,

  // MCP Client Versions Routes
  // IMPORTANT: Routes with literal paths (e.g., /compare) must come BEFORE
  // routes with path parameters (e.g., /:versionId) to ensure correct matching.
  LIST_MCP_CLIENT_VERSIONS_ROUTE,
  CREATE_MCP_CLIENT_VERSION_ROUTE,
  COMPARE_MCP_CLIENT_VERSIONS_ROUTE,
  GET_MCP_CLIENT_VERSION_ROUTE,
  ACTIVATE_MCP_CLIENT_VERSION_ROUTE,
  RESTORE_MCP_CLIENT_VERSION_ROUTE,
  DELETE_MCP_CLIENT_VERSION_ROUTE,
] as const;
